import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

const Pricecalculator = (props) => {
  const showVat = useSelector((state) => state.vat.value);
  const isRecommendedPrice = useSelector((state) => state.recommendedprice.isrecommendedprice);

  if (showVat === false) {
    if (props.isauthorized === true) {
      if (isRecommendedPrice) {
        return (
          <Fragment>
            <div>{props.recommendedpriceexcludingvat}</div>
          </Fragment>
        );
      } else {
        return (
          <Fragment>
            <div className={`${props.campaignprice && 'hascampaignprice'} `}>
              {props.netpriceexcludingvat}
            </div>
            {props.campaignprice && (
              <div className="campaign">{props.campaignprice}</div>
            )}
          </Fragment>
        );
      }
    } else {
      return (
        <Fragment>
          <div className={`${props.campaignprice && 'hascampaignprice'} `}>
            {props.recommendedpriceexcludingvat}
          </div>
          {props.campaignprice && (
            <div className="campaign">{props.campaignprice}</div>
          )}
        </Fragment>
      );
    }
  } else {
    if (props.isauthorized === true) {
      if (isRecommendedPrice) {
        return (
          <Fragment>
            <div>{props.recommendedpriceincludingvat}</div>
          </Fragment>
        );
      } else {
        return (
          <Fragment>
            <div className={`${props.campaignprice && 'hascampaignprice'} `}>
              {props.netpricincludingvat}
            </div>
            {props.campaignprice && (
              <div className="campaign">{props.campaignpriceincludingvat}</div>
            )}
          </Fragment>
        );
      }
    } else {
      return (
        <Fragment>
          <div className={`${props.campaignprice && 'hascampaignprice'} `}>
            {props.recommendedpriceincludingvat}
          </div>
          {props.campaignprice && (
            <div className="campaign">{props.campaignpriceincludingvat}</div>
          )}
        </Fragment>
      );
    }
  }
};
export default Pricecalculator;
